import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const PdfGenerationModal = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal closeModal={onClose} title={t('pdfModal.generation.title')} fullscreen>
            <div>{t('pdfModal.generation.content')}</div>
        </Modal>
    );
};

export default PdfGenerationModal;
